/** Метрика приемки */
// Получение метрики по типу
export const METRIC_PIECE_DATA = 'METRIC_PIECE_DATA';
export const METRIC_PIECE_DATA_SUCCESS = 'METRIC_PIECE_DATA_SUCCESS';
export const METRIC_PIECE_DATA_FAIL = 'METRIC_PIECE_DATA_FAIL';

// Получение метрики по типу / сводно
export const METRIC_PIECE_DATA_ALL = 'METRIC_PIECE_DATA_ALL';
export const METRIC_PIECE_DATA_ALL_SUCCESS = 'METRIC_PIECE_DATA_ALL_SUCCESS';
export const METRIC_PIECE_DATA_ALL_FAIL = 'METRIC_PIECE_DATA_ALL_FAIL';

// Получение списка метрик
export const METRIC_PIECE_TYPES_LIST = 'METRIC_PIECE_TYPES_LIST';
export const METRIC_PIECE_TYPES_LIST_SUCCESS = 'METRIC_PIECE_TYPES_LIST_SUCCESS';
export const METRIC_PIECE_TYPES_LIST_FAIL = 'METRIC_PIECE_TYPES_LIST_FAIL';

/** Метрика активности */
// Получение метрики активности / сводно
export const METRIC_USER_ACTIVITY_SHORT = 'METRIC_USER_ACTIVITY_SHORT';
export const METRIC_USER_ACTIVITY_SHORT_SUCCESS = 'METRIC_USER_ACTIVITY_SHORT_SUCCESS';
export const METRIC_USER_ACTIVITY_SHORT_FAIL = 'METRIC_USER_ACTIVITY_SHORT_FAIL';

// Получение метрики активности / детально
export const METRIC_USER_ACTIVITY_DETAILED = 'METRIC_USER_ACTIVITY_DETAILED';
export const METRIC_USER_ACTIVITY_DETAILED_SUCCESS = 'METRIC_USER_ACTIVITY_DETAILED_SUCCESS';
export const METRIC_USER_ACTIVITY_DETAILED_FAIL = 'METRIC_USER_ACTIVITY_DETAILED_FAIL';

/** Метрика добавленных складов */
export const METRIC_ADDED_STOCKS = 'METRIC_ADDED_STOCKS';
export const METRIC_ADDED_STOCKS_SUCCESS = 'METRIC_ADDED_STOCKS_SUCCESS';
export const METRIC_ADDED_STOCKS_FAIL = 'METRIC_ADDED_STOCKS_FAIL';
